import { formatAmount } from "@/base/global"
const isNotNull = (val) => !!val && val != '' && val != '--'
export const value = (val) => isNotNull(val) ? val : '--'
export const isFunc = (func) => Object.prototype.toString.call(func) === '[object Function]'
export const fields = {
    405: {
        '年报年份': true,
        '发布日期': true,
    },
    482: {
        '法定代表人': true,
        '经营状态': true,
        '注册资本': function (func) {
            const val = func('注册资本')
            return isNotNull(val) && val != 'null' ? val.match(/^[0-9]*$/) ? `${val}${func('货币单位')}${func('货币类型')}` : formatAmount(val) : '--'
        },
        "登记机关": true,
        '成立日期': true,
        "核准日期": true,
        "统一社会信用代码": true,
        "组织机构代码": true,
        "纳税人识别号": true,
        "工商注册号": true,
        "企业类型": true,
        "营业期限": function (func) {
            let [d0, d1] = [value(func('经营期限自')), value(func('经营期限至'))];
            return `${d0}至${d1}`
        },

        "所属行业": function (func) {
            let [d0, d1, d2, d3] = [func('行业大类名'), func('行业小类名'), func('三级行业名称'), func('四级行业名称')];
            if (isNotNull(d0) && isNotNull(d1) && isNotNull(d2) && isNotNull(d3)) return `${d0}>${d1}>${d2}>${d3}`
            if (isNotNull(d0) && isNotNull(d1) && isNotNull(d2) && !isNotNull(d3)) return `${d0}>${d1}>${d2}`
            if (isNotNull(d0) && isNotNull(d1) && !isNotNull(d2) && !isNotNull(d3)) return `${d0}>${d1}`
            if (isNotNull(d0) && !isNotNull(d1) && !isNotNull(d2) && !isNotNull(d3)) return `${d0}`
            return value(d1)
        },
        "注册地址": true,
        "经营范围": true,
    },
    748: {
        "商标图片": true,
        "商标名称": true,
        "商标状态": true,
        "商标注册号": true,
        "申请日期": true,
        "国际分类": true,
        "注册公告日期": true,
        "专用权期限": true,
    },
    488: {
        "专利名称": true,
        "专利类型": true,
        "申请号": true,
        "申请日期": true,
        "公告日期": true,
        "公告号": true,
        "发明人": true,
    },
    800: {
        "名称": true,
        "分类": true,
        "头像": true,
        "二维码": true
    }
}


